import { Link } from "react-router-dom";
import "../Styles/Card.css";
import { timeAgo } from "../utils/format";
import { GeoIcon } from "./icons/GeoIcon";
import LiveIcon from "./icons/LiveIcon";
import type { VenueFeed } from "../data/types";
import DefaultAvatar from "./DefaultAvatar";
import LikeButton from "./LikeButton";
import TrackCover from "./TrackCover";
import { venuePath } from "../utils/routes";

type CardProps = {
  feedObj: VenueFeed;
};

/** Samma gräns som servern räknar LIVE på, se api/venueStatus.js. */
const LIVE_MINUTES = 5;

export default function VenueCard({ feedObj }: CardProps) {
  const ageMinutes = (Date.now() - feedObj.time.getTime()) / 60000;
  const isLive = ageMinutes <= LIVE_MINUTES;

  return (
    <div className="card-wrapper card-venue">
      <div className="card-header">
        <GeoIcon size={16} className={"geo-icon"} />
        {/* Ett venue-inlägg är inte per definition färskt. Stod det "Live
            Now" på ett dygn gammalt inlägg ljög kortet. */}
        {isLive ? (
          <p className="text-pink">Live now</p>
        ) : (
          <p className="text-damper">{timeAgo(feedObj.time)}</p>
        )}
      </div>

      <Link className="card-top card-top-link" to={venuePath(feedObj.venueId)}>
        <DefaultAvatar
          avatarUrl={feedObj.venueImageUrl ?? undefined}
          name={feedObj.venueName}
        />

        <div className="group-column">
          <p className="text-b">{feedObj.venueName}</p>
          {feedObj.address && <p className="text-pink-400">{feedObj.address}</p>}
        </div>
      </Link>

      <div className="card-center">
        <p className="text">Currently playing:</p>

        <div className="preview-container-venue">
          <TrackCover src={feedObj.albumCover} />

          <div className="group-column card-track-meta">
            <p className="text-l">{feedObj.songTitle}</p>
            <p className="text-damp">{feedObj.artist}</p>
            {feedObj.year && (
              <p className="text-damper margin-top">{feedObj.year}</p>
            )}
          </div>

          {isLive && <LiveIcon />}
        </div>
      </div>

      <div className="card-bottom">
        <LikeButton
          postId={feedObj.id}
          likes={feedObj.likes}
          likedByMe={feedObj.likedByMe}
        />
      </div>

    </div>
  );
}
